// extracted by mini-css-extract-plugin
export default {"box":"scY_GeP8RLeWmYr6Hfe0","title":"KR829UUFkw6SAmGxHpeP","description":"g1Ih1Rm2N6AUsFrP7vkn","note":"JSvi4hUt1c6mrRur5j7M"};